import { useState, useEffect } from 'react';
import ReasonService from '../service/ReasonService';

export function useGetReason() {
  const [reasonList, setReasonList] = useState([]);

  useEffect(() => {
    ReasonService.getAll(1, 1000, {})
      .then((response) => {
        if (response.data.data.length > 0) {
          let reasonOptionList = response.data.data.map((reason) => {
            return { motive: reason.id, label: reason.name };
          });

          setReasonList(reasonOptionList);
        }
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, []);

  return {
    reasonList,
    setReasonList
  };
}
